import axios from 'axios';

export default axios.create({
  baseURL: '/wp-json/macs/v1/unique_data' // local
});
